export default "__VITE_ASSET__DaockD3A__"